import { useState, useEffect } from "react";
import Layout from "./Layout.js";
import {
  feedback_summary,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { handleError } from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";
import { Frown, Laugh, Meh } from "lucide-react";
import RecentActivity from "./RecentActivityFeedback.js";
import RecentActivityFeedback from "./RecentActivityFeedback.js";

const Feedbacks = () => {
  const [sosAlerts, setSosAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(feedback_summary, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          setSosAlerts(Response.data);
          console.log(Response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const stats = [
    {
      title: "Negative Feedbacks",
      value: sosAlerts?.cards?.negative || 0,
      stat_name: `High Priority`,
      priority: "high-priority",
      valueClass: "high",
      icon: <Frown />,
    },
    {
      title: "Neutral Feedbacks",
      value: sosAlerts?.cards?.neutral || 0,
      stat_name: `Active Reports`,
      priority: "medium-priority",
      valueClass: "medium",
      icon: <Meh />,
    },
    {
      title: "Positive Feedbacks",
      value: sosAlerts?.cards?.positive || 0,
      stat_name: `Open Locations`,
      priority: "low-priority",
      valueClass: "low",
      icon: <Laugh size={30} />,
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Feedback Management</h2>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`stat-card ${stat.priority}`}
                // onClick={stat.action}
              >
                <div className="stat-card-inner">
                  <div>
                    <p className={`stat-value ${stat.valueClass}`}>
                      {isLoading ? "..." : stat.value}
                    </p>
                    <p className={`stat-value statPrio ${stat.valueClass}`}>
                      {stat.title}
                    </p>
                  </div>
                  <div className={`stat-icons ${stat.priority}`}>
                    {stat.icon}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {sosAlerts && (
            <RecentActivityFeedback
              systemStatus={sosAlerts ? sosAlerts.action_required : []}
              recentData={sosAlerts ? sosAlerts.recent_feedback : []}
            />
          )}
        </div>
      </Layout>
    </>
  );
};

export default Feedbacks;
